import React from "react";
import Button from "@mui/material/Button";
import "../styles.css";
import { useEffect } from "react";
import { Image } from "react-bootstrap";
import ContainerBody from "../components/ContainerBody";
import ButtonLink from "../components/ButtonLink";
import ContainerNav from "../components/ContainerNav";
import Input from "@mui/material/Input";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import ContainerRoot from "../components/ContainerRoot";
import { useTranslation } from "react-i18next";

export default function ChooseImage(props) {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(props.language);
  }, [i18n, props.language]);

  const [imageUrl, setImageUrl] = useState(null);

  const handleFileSelect = (event) => {
    const selectedFile = event.target.files[0];
    const imageUrl = URL.createObjectURL(selectedFile);
    props.setImage(selectedFile);
    setImageUrl(imageUrl);
  };

  useEffect(() => {
    return () => {
      if (props.imageUrl) {
        URL.revokeObjectURL(props.imageUrl);
      }
    };
  }, [props.imageUrl]);

  const handleButtonClick = () => {
    document.getElementById("file-input").click();
  };

  return (
    <ContainerRoot>
      <ContainerBody>
        <Typography>{t("Choose image")}</Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<CameraAltIcon />}
          onClick={handleButtonClick}
        >
          {t("Choose image")}
        </Button>
        <Input
          type="file"
          id="file-input"
          accept="image/*"
          onChange={handleFileSelect}
          style={{ display: "none" }}
        />
        {imageUrl && (
          <Image
            src={imageUrl}
            roundedCircle
            style={{ maxWidth: "100%", height: "auto", marginTop: "1rem" }}
          />
        )}
      </ContainerBody>
      <ContainerNav>
        <ButtonLink url="/" title={t("Back")} />
        <ButtonLink url="/prompt" title={t("Next")} color="primary" />
      </ContainerNav>
    </ContainerRoot>
  );
}
